import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getInquiryList } from './myPageApi';
import { inquiryStatusLabels } from './inquiryStatus';

// 내가 등록한 문의 목록 화면: 번호·제목·답변 상태·작성일을 한 줄로 보여주고, 누르면 상세로 이동한다.
export default function InquiryListSection() {
    const [inquiries, setInquiries] = useState(null);
    const [error, setError] = useState('');

    // 문의 목록을 불러온다.
    const load = useCallback(async () => {
        setError('');
        setInquiries(null);
        try {
            setInquiries(await getInquiryList());
        } catch (loadError) {
            setError(loadError.message);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const heading = <div className="my-page-section-heading"><div><h2>문의 조회하기</h2><p>내가 등록한 문의와 답변 상태를 확인하세요.</p></div></div>;
    if (error) return <>{heading}<div className="my-page-card my-page-placeholder" role="alert"><h3>문의 목록을 불러오지 못했습니다</h3><p>{error}</p><button type="button" className="my-page-button my-page-retry" onClick={load}>다시 시도</button></div></>;
    if (!inquiries) return <>{heading}<p className="my-page-notice" role="status">문의 목록을 불러오고 있습니다.</p></>;

    return <>
        {heading}
        {inquiries.length === 0 ? <div className="my-page-card my-page-placeholder"><h3>아직 문의 내역이 없습니다</h3><p>서비스 이용 중 궁금한 점이 있으면 문의를 남겨주세요.</p></div> : <ul className="my-page-card my-page-inquiry-list">
            {inquiries.map((item, index) => <li key={item.id}>
                <Link to={`/mypage/inquiry/${encodeURIComponent(item.id)}`}>
                    <span className="my-page-inquiry-number">{inquiries.length - index}</span>
                    <span className="my-page-inquiry-title">{item.title}</span>
                    <span className={`my-page-inquiry-status${item.status === 'answered' ? ' done' : ''}`}>{inquiryStatusLabels[item.status] || item.status || '—'}</span>
                    <span className="my-page-meta">{item.created_at}</span>
                </Link>
            </li>)}
        </ul>}
    </>;
}
